const hots = () => import("../../view/jofph/news/hots");
const hotsAdd = () => import("../../view/jofph/news/hots/add");
const notice = () => import("../../view/jofph/news/notice");
const noticeAdd = () => import("../../view/jofph/news/notice/add");
const meeting = () => import("../../view/jofph/news/meeting");
const meetingAdd = () => import("../../view/jofph/news/meeting/add");
const partner = () => import("../../view/jofph/news/partner");
const partnerAdd = () => import("../../view/jofph/news/partner/add");

const model = "/jofph";
const path = model + "/news";

export default [
  {
    // 热点列表
    path: path + "/hots",
    component: hots,
    name: "news-hots",
  },
  {
    // 新增热点
    path: path + "/hots/add",
    component: hotsAdd,
    name: "hots-add",
  },
  {
    // 编辑热点
    path: path + "/hots/:hots_id",
    component: hotsAdd,
    name: "hots-edit",
  },
  {
    // 公告列表
    path: path + "/notice",
    component: notice,
    name: "news-notice",
  },
  {
    // 新增公告
    path: path + "/notice/add",
    component: noticeAdd,
    name: "notice-add",
  },
  {
    // 编辑公告
    path: path + "/notice/:notice_id",
    component: noticeAdd,
    name: "notice-edit",
  },
  {
    // 会议列表
    path: path + "/meeting",
    component: meeting,
    name: "news-meeting",
  },
  {
    // 新增会议
    path: path + "/meeting/add",
    component: meetingAdd,
    name: "meeting-add",
  },
  {
    // 编辑会议
    path: path + "/meeting/:meeting_id",
    component: meetingAdd,
    name: "meeting-edit",
  },
  {
    // 热点列表
    path: path + "/partner",
    component: partner,
    name: "news-partner",
  },
  {
    // 新增热点
    path: path + "/partner/add",
    component: partnerAdd,
    name: "hots-partner",
  },
  {
    // 编辑热点
    path: path + "/partner/:partner_id",
    component: partnerAdd,
    name: "partner-edit",
  },
];
